export const onboardingQuestionsExceptions = [
  "welcome", "agreement", "get-started"
];

export const AGREEMENT = 'agreement';
export const BEGIN_AGREEMENT = 'begin_agreement';